import { getPictureUrl } from 'core/api/pictures';
import PreloadImage from 'core/components/common/PreloadImage';
import { button, buttonAccent, link } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { isHtmlEmpty } from 'core/utils';
import React from 'react';
import { Broker } from 'site/graphql';
import { BROKERS_MAIN_COUNT } from './const';

const BrokersMainTable: React.FC<{ brokers: Broker[] } & WithStyles<typeof styles>> = ({ brokers, classes }) => {
    // заполняем пустыми столбцами, если кол-во брокеров < BROKERS_MAIN_COUNT, иначе таблица будет разъезжаться
    const empty = [];
    for (let i = brokers.length; i < BROKERS_MAIN_COUNT; i++) {
        empty.push(<th key={i} />);
    }

    return (
        <table className={classes.table}>
            <thead>
                <tr>
                    {brokers.map(broker => (
                        <th className={classes.head} key={broker.id}>
                            {broker.name}
                        </th>
                    ))}
                    {empty}
                </tr>
            </thead>
            <tbody>
                <tr>
                    {brokers.map(broker =>
                        broker.pictureId ? (
                            <td key={broker.id}>
                                <a href={broker.link} target="_blank" rel="noopener noreferrer">
                                    <PreloadImage
                                        src={getPictureUrl(broker.pictureId, '200x200', null)}
                                        alt={broker.name}
                                        imgClassName={classes.image}
                                    />
                                </a>
                            </td>
                        ) : (
                            <td key={broker.id} />
                        ),
                    )}
                </tr>
                <tr>
                    {brokers.map(broker => (
                        <td key={broker.id}>
                            <a className={classes.link} href={broker.link} target="_blank" rel="noopener noreferrer">
                                Узнай больше
                            </a>
                        </td>
                    ))}
                </tr>
                <tr>
                    {brokers.map(broker => (
                        <td key={broker.id}>
                            <a href={broker.link} target="_blank" rel="noopener noreferrer" className={classes.button}>
                                Открыть счет
                            </a>
                        </td>
                    ))}
                </tr>
                <tr className={classes.contentTop}>
                    {brokers.map(broker => (
                        <td key={broker.id}>
                            <b>Комиссия:</b>
                            <br />
                            {broker.commission ? broker.commission : '-'}
                        </td>
                    ))}
                </tr>
                <tr className={classes.contentTop}>
                    {brokers.map(broker => (
                        <td key={broker.id}>
                            <b>Минимум:</b>
                            <br />
                            {broker.minimum ? broker.minimum : '-'}
                        </td>
                    ))}
                </tr>
                <tr className={classes.contentTop}>
                    {brokers.map(broker => (
                        <td key={broker.id}>
                            <b>Особенности:</b>
                            <br />
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: !isHtmlEmpty(broker.features) ? broker.features : '-',
                                }}
                            />
                        </td>
                    ))}
                </tr>
                <tr className={classes.contentTop}>
                    {brokers.map(broker => (
                        <td key={broker.id}>
                            <b>Предложение:</b>
                            <br />
                            {broker.sentence ? broker.sentence : '-'}
                        </td>
                    ))}
                </tr>
                <tr>
                    {brokers.map(broker => (
                        <td key={broker.id}>
                            <a href={broker.link} target="_blank" rel="noopener noreferrer" className={classes.button}>
                                Открыть счет
                            </a>
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        table: {
            display: 'block',
            overflowX: 'auto',
            borderCollapse: 'collapse',
            fontSize: 0.8125 + 'rem',

            '& tr td': {
                width: '20%',
            },

            '& tr th': {
                width: '20%',
                textAlign: 'center',
            },

            '& tr td+td': {
                borderLeft: '1px solid #EEEEEE',
            },

            '& tbody tr:hover': {
                backgroundColor: '#e5e5e5',
            },

            '& td, & th': {
                borderBottom: 0,
                padding: '8px 10px 10px 10px',
            },
        },
        contentTop: {
            verticalAlign: 'top',
        },
        button: {
            ...button(theme),
            ...buttonAccent(theme),
            backgroundColor: theme.colors.accent,
        },
        link: {
            ...link('#597DA3'),
        },
        image: {
            width: 200,
            margin: '0 auto',
            display: 'block',
        },
        head: {
            fontWeight: 'bold',
            fontSize: '0.9rem',
            color: '#212121',
        },
    });

export default injectSheet(styles, 'BrokersMainTable')(BrokersMainTable);
